import { Modal } from "react-bootstrap";
import { useState } from "react";
import { Datasets } from "../../components/Dataset/Dataset";
import "../../styles/DatasetPage.css";
import "../../styles/org-buttons.css";
import NavigationBar from "../../components/NavBar/NavBar";
import DatasetWorkspaceShell from "../../components/Dataset/DatasetWorkspaceShell";
import PickerPage from "./pages/PickerPage";
import CutterPage from "./pages/CutterPage";
import { buttonText } from "../../utils/buttonText";
import { pageText } from "../../utils/pageText";

function DatasetPage() {
  return (
    <div>
      <NavigationBar />
      <DatasetWorkspaceShell>
        <Datasets
          CustomizedContent={CustomizedContent}
          overviewTitle="Datasets"
          overviewDescription="Browse, split, and manage datasets for downstream annotation and training workflows."
        />
      </DatasetWorkspaceShell>
    </div>
  );
}

const nameToTitleName = {
  picker: "dataset picker page",
  cutter: "dataset cutter page",
};

function CustomizedContent(props) {
  const { item } = props;

  const [pageName, setPageName] = useState(null);

  const showModel = pageName && nameToTitleName.hasOwnProperty(pageName);

  const isCommon = item.folder !== "Yes" && item.table !== "Yes";
  if (!isCommon) {
    return (
      <div className="acquisition-data-customized-content">
        <p>{pageText("You can not split dataset that represents a folder/table")}</p>
        {item.folder === "Yes" && (
          <div>
            <p>{pageText("If you want to split a folder dataset,")}</p>
            <p>
              {pageText("please click 'Folders' tab, but this feat is not implemented yet.")}
            </p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="dataset-customized-content">
      <p className="card-text">{pageText("Samples:")} {item.samples?.length || 0}</p>
      <button
        type="button"
        className="org-btn org-btn-secondary dataset-action-btn"
        onClick={() => setPageName("picker")}
      >
        {buttonText("Picker")}
      </button>
      <button
        type="button"
        className="org-btn org-btn-secondary dataset-action-btn"
        onClick={() => setPageName("cutter")}
      >
        {buttonText("Cutter")}
      </button>
      <DatasetPageModal
        show={showModel}
        onHide={() => setPageName(null)}
        pageName={pageName}
        {...props}
      />
    </div>
  );
}

function DatasetPageModal(props) {
  const { show, onHide, pageName, ...contentProps } = props;

  const nameToComponent = {
    picker: <PickerPage {...contentProps} />,
    cutter: <CutterPage {...contentProps} />,
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton closeLabel={buttonText("Close")}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ marginLeft: "10px" }}
          >
            {nameToTitleName[pageName]}
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>{nameToComponent[pageName]}</Modal.Body>
    </Modal>
  );
}

export default DatasetPage;
